import { cn } from "@facade/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("relative overflow-hidden rounded-md bg-muted", className)}
      {...props}
    >
      <div
        className="
          absolute inset-0
          w-full
          animate-[skeleton-shimmer_1.5s_infinite]
        "
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.15) 50%, transparent 100%)",
        }}
      />
    </div>
  );
}

export { Skeleton };
